import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CheckboxComponent } from './checkbox.component';

@NgModule({
    imports: [CommonModule, MatCheckboxModule],
    declarations: [CheckboxComponent],
    exports: [CheckboxComponent],
})
export class FiCheckboxModule {}
